import React, { useContext, useEffect } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { Layout } from "../pages/afterAuth/layout/Layout";
import RouteContext from "../utils/context/RouteContext";

const PrivateRoute = ({ Component }) => {
  const navigate = useNavigate();
  const { allowedRoutes } = useContext(RouteContext);
  const location = useLocation();

  useEffect(() => {
    const interval = setInterval(() => {
      const token = localStorage.getItem("token");
      if (!token) {
        clearInterval(interval);
        navigate("/login");
      }
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [navigate]);


  const token = localStorage.getItem("token");

  console.log(allowedRoutes, "aaaaaaaaaa");

  return token ? <Component /> : <Navigate to="/login" />;
};
export default PrivateRoute;
